import { connect } from 'react-redux';
import { toggleNDAPreview } from 'pap/ducks/workflow';
import NDAPreviewButton from 'pap/components/common/nda_preview_button';

export default connect(() => ({}), {
  onToggle: toggleNDAPreview
})(NDAPreviewButton);



// WEBPACK FOOTER //
// ./pap/containers/nda_preview_button.js